import { render, staticRenderFns } from "./RootInput.vue?vue&type=template&id=a281c60e&scoped=true&"
import script from "./RootInput.vue?vue&type=script&lang=js&"
export * from "./RootInput.vue?vue&type=script&lang=js&"
import style0 from "./RootInput.vue?vue&type=style&index=0&id=a281c60e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a281c60e",
  null
  
)

export default component.exports